module.exports = __webpack_public_path__ + "img/icon_star_rate_inactive_gray_bg.98450315.svg";